<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">公共仪器平台</span></p>'
      + '<p style="margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">作为转化医学研究支撑系统，设施为转化医学研究团队提供生物医药、诊断试剂、医学材料、 诊疗装备、医学数据等多领域所需的大型仪器设备共享服务，涵盖电镜 - 影像，光谱、波谱、质谱， 新药研发与工艺安全性评价，诊疗装备开发服务，生物医学数据分析等领域分析检测与制造技术， 为用户提供自主操作、送样检测、CMA 报告、按图加工等多种类型的仪器共享模式。同时，依托计 算平台能力，设施为用户提供云计算高性能计算、AI 超算、大数据云存储等数据服务。</span></p>'

      +'<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/ggyqpt1.png" style="width: 900px; margin-right: 16px;margin-bottom: 16px;" width="960px"  border="0" vspace="0" alt=""></p>'
      + '<p style="margin-bottom : 10px; margin-left: 60px; "><span style="font-size: 18px; color: #033d80; font-weight: bold">▶ 公共仪器平台 / 分析测试中心 </span><span style="font-size: 18px; "> 网站: http://iac.sjtu.edu.cn/</span></p>'
      + '<p style="margin-bottom : 20px; margin-left: 60px; "><span style="font-size: 18px; color: #033d80; font-weight: bold">▶ 高性能计算平台 </span><span style="font-size: 18px; "> 网站: https://hpc.sjtu.edu.cn/</span></p>'

    //+'<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/ggyqpt2.png" style="width: 920px; margin-right: 16px;margin-bottom: 16px;" width="960px"  border="0" vspace="0" alt=""></p>'
      },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service1/index.vue